<div class="container m" *ngIf="this.nextConfig.layout === 'horizontal' && this.nextConfig.subLayout === 'horizontal-2'; else mainHeader">
  <ng-container *ngTemplateOutlet="mainHeader"></ng-container>
</div>
<ng-template #mainHeader>
  <!--<div class="m-header">
    <a href="javascript:" class="mobile-menu" id="mobile-collapse" (click)="navCollapse()"><span></span></a>
    <a [routerLink]="['/dashboard/analytics']" class="b-brand">
      <img id="main-logo" src="assets/images/IFSLogo.png" alt="" class="logo" *ngIf="this.nextConfig.navBrandColor !== 'brand-default' || this.nextConfig.headerBackColor !== 'header-default'">
      <img src="assets/images/IFSLogo.png" alt="" class="logo" *ngIf="this.nextConfig.navBrandColor === 'brand-default' && this.nextConfig.headerBackColor === 'header-default'">
      <img src="assets/images/logo-icon.png" alt="" class="logo-thumb">
    </a>
    <a class="mob-toggler" [ngClass]="{'on' : this.menuClass}" href="javascript:" (click)="toggleMobOption()"><i class="feather icon-more-vertical"></i></a>
  </div>-->
  <div class="m-header mheader-padding">
    <a href="javascript:" id="mobile-collapse" (click)="navCollapse()"><span class="navbar-toggler-icon"></span></a>
    <img id="main-logo" src="assets/images/IFSLogo.png" alt="" class="logo">
    <div class="ps-3">
      <span class="WSLogo navWSLogo">IFS Vessel Interface for {{shipName}}</span>
      <div class="pt-1">
        <span class="IFSVersion">
          {{IFSVersion}}
        </span>
      </div>
      <div class="pt-1 tooltip-container">
        <span class="tooltip-target">
          {{storageUsed}} storage used<i class="fa fa-exclamation-circle" style="color: red;" *ngIf="percentageUsed >= 100"></i>
        </span>
        <div class="tooltip-box">
          <p *ngIf="percentageUsed >= 100">Some IVI possibilities can work incorrectly.<br />
          Please submit all pending orders, daily meals,<br />
          stocks and clean it by pressing clean button</p>
          <button class="tooltip-button" (click)="onCleanClicked()">Clean</button>
        </div>
        <br />
      </div>
    </div>
  </div>
  <div class="navbar-collapse" [style.display]="this.collapseStyle">
    <app-nav-left class="me-auto"></app-nav-left>
    <app-nav-right class="ms-auto" (onNavToggleChat)="navToggleChat()"></app-nav-right>
  </div>
</ng-template>
